import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-export-dialog', {
    attrs: {
      "query": _vm.exportQuery,
      "formValid": _vm.formValid,
      "jobType": "export",
      "format": "csv",
      "resource": "influx-measurements"
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close-export-dialog');
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n    " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.csvExport.titleSlot')) + "\n  ")];
      },
      proxy: true
    }, {
      key: "subtitleParagraph",
      fn: function () {
        return [_vm._v("\n    " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.csvExport.subtitleSlot')) + "\n  ")];
      },
      proxy: true
    }, {
      key: "fields",
      fn: function () {
        return [_c('core-date-time-picker', {
          staticStyle: {
            "margin-bottom": "30px !important"
          },
          attrs: {
            "from": _vm.start / 1000,
            "to": _vm.end / 1000,
            "isRange": ""
          },
          on: {
            "date:picked": _vm.datePicked
          }
        }), _c(VAutocomplete, {
          attrs: {
            "items": _vm.variables,
            "color": _vm.color,
            "outlined": _vm.inpOutlined,
            "filled": _vm.inpFilled,
            "clearable": "",
            "multiple": "",
            "chips": "",
            "label": _vm.$i18n_t('NiotaClassic.Devices.csvExport.variablesSelectHint'),
            "item-text": "label",
            "return-object": ""
          },
          on: {
            "change": _vm.variablesChanged
          },
          model: {
            value: _vm.exportVariables,
            callback: function ($$v) {
              _vm.exportVariables = $$v;
            },
            expression: "exportVariables"
          }
        }), _c(VRadioGroup, {
          staticStyle: {
            "margin-top": "0",
            "padding-top": "0"
          },
          model: {
            value: _vm.exportQuery.outputType,
            callback: function ($$v) {
              _vm.$set(_vm.exportQuery, "outputType", $$v);
            },
            expression: "exportQuery.outputType"
          }
        }, [_c(VRadio, {
          attrs: {
            "label": _vm.$i18n_t('NiotaClassic.Devices.csvExport.oneFilePerDeviceVariable'),
            "color": _vm.color,
            "value": "one-file-per-device-variable"
          }
        }), _c(VRadio, {
          attrs: {
            "label": _vm.$i18n_t('NiotaClassic.Devices.csvExport.oneFilePerDevice'),
            "color": _vm.color,
            "value": "one-file-per-device"
          }
        })], 1)];
      },
      proxy: true
    }])
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };